import styled from 'styled-components';

export const ExecutionCard = styled.div(
  ({ theme }) => `
  background-color: ${theme.colors.surface.background.gray.intense};
  border: 1px solid ${theme.colors.surface.border.gray.subtle};
  border-radius: ${theme.border.radius.medium}px;
  padding: ${theme.spacing[4]}px;
  margin-bottom: ${theme.spacing[3]}px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: ${theme.colors.surface.border.gray.muted};
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  }
`
);

export const LogStep = styled.div<{ status: string }>(
  ({ theme, status }) => `
  display: flex;
  align-items: flex-start;
  gap: ${theme.spacing[3]}px;
  padding: ${theme.spacing[3]}px;
  background-color: ${
    status === 'success' 
      ? theme.colors.feedback.background.positive.subtle 
      : status === 'failed' 
        ? theme.colors.feedback.background.negative.subtle 
        : status === 'warning'
          ? theme.colors.feedback.background.notice.subtle
          : theme.colors.surface.background.gray.subtle
  };
  border-radius: ${theme.border.radius.small}px;
  margin-bottom: ${theme.spacing[2]}px;
`
);

export const ClickableBox = styled.div`
  cursor: pointer;
`;
